import { render, staticRenderFns } from "./LogoCardHorizontal.vue?vue&type=template&id=4858f469&"
import script from "./LogoCardHorizontal.vue?vue&type=script&lang=js&"
export * from "./LogoCardHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports